import styled from 'styled-components/macro';
import { Icon, Image } from '~/components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  background-color: ${({ theme }) => theme.dark5};
  color: ${({ theme, eventsFailed }) =>
    eventsFailed ? theme.dark : theme.light};
  padding: ${({ eventsFailed }) => (eventsFailed ? 0 : 10)}px;
  position: relative;
`;

export const ShieldBackground = styled.div`
  width: 50%;
  height: calc(100% - 10px);
  position: absolute;
  ${({ homeTeamShieldBg }) => (homeTeamShieldBg ? 'left:0;' : 'right:0;')}
  background-image: ${({ homeTeamShieldBg }) =>
    homeTeamShieldBg ? `url(${homeTeamShieldBg})` : ''}
    ${({ awayTeamShieldBg }) =>
      awayTeamShieldBg ? `url(${awayTeamShieldBg})` : ''};
  background-repeat: no-repeat;
  background-position: ${({ homeTeamShieldBg }) =>
    homeTeamShieldBg ? 'calc(0% - 80px)' : 'calc(100% + 80px)'} center;
  background-attachment: fixed;
  filter: grayscale(100%);
  background-size: 213px auto;
  opacity:0.3;
`;

export const Wrapper = styled.div`
  max-width: 200px;
  width: 100%;
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 40px auto 40px;
  position: sticky;
  top: ${({ tabletMode }) => (tabletMode ? '0px' : '40px')};
  margin-bottom: 20px;
  z-index: 1;
  box-shadow: 0px 14px 13px ${({ theme }) => theme.dark5};
  background-color: ${({ theme }) => theme.dark5};
`;

export const Shield = styled(Image)`
  width: 40px;
  height: 40px;
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const TimelineList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TimelineItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'label time empty';
  align-items: end;
  padding-bottom: 30px;
  position: relative;
  ${({ isLocal }) =>
    !isLocal
      ? `
    grid-template-areas: 'empty time label';
    justify-items: flex-end;
    & > div {
      &:first-child {
        align-items: flex-end;
        text-align: right;
      }
    }
  `
      : null}
`;

export const Line = styled.div`
  position: absolute;
  width: 1px;
  height: 100%;
  left: 50%;
  bottom: 0;
  background-color: ${({ theme }) => theme.light};
  z-index: 1;
`;

export const TimelineTime = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px ${({ theme }) => theme.light};
  border-radius: 100%;
  width: 30px;
  height: 30px;
  font-size: 10px;
  grid-area: time;
  background-color: ${({ theme }) => theme.dark};
  z-index: 2;
`;

export const TimelineLabel = styled.div`
  grid-area: label;
  font-size: 10px;
  text-transform: uppercase;
`;

export const Tooltip = styled.span`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: ${({ isLocal }) => (isLocal ? 'flex-start' : 'flex-end')};

  &:hover {
    .tooltip {
      opacity: 1;
      z-index: 1;
      transition: opacity ease 0.4s;
    }
  }

  .tooltip {
    background-color: ${({ theme, competition }) =>
      competition === 1 ? theme.coral : theme.turquoise};
    border-radius: 4px;
    padding: 2px 10px;
    white-space: nowrap;
    opacity: 0;

    position: absolute;
    top: -22px;
    z-index: -1;
  }
`;

export const Label = styled.span``;

export const TimelineLabelIcon = styled(Icon)`
  margin-bottom: 10px;
`;

export const EmptyDataText = styled.p`
  font-size: ${({ theme }) => theme.h3}px;
  text-align: center;
`;
